import { CALL_API } from '@aftonbladet/redux-api-middleware';

import { LATEST_ARTICLES_REQUEST, LATEST_ARTICLES_SUCCESS, LATEST_ARTICLES_FAILURE } from './types';

/* eslint-disable import/prefer-default-export */
export const fetchLatestArticlesAction = ({ endpoint, force = false }) => ({
    [CALL_API]: {
        endpoint,
        method: 'GET',
        types: [LATEST_ARTICLES_REQUEST, LATEST_ARTICLES_SUCCESS, LATEST_ARTICLES_FAILURE],
        bailout: (state) => !force && !!state.latestArticles.length,
    },
});
/* eslint-enable import/prefer-default-export */



/** WEBPACK FOOTER **
 ** ./src/redux/actions/latest-articles.js
 **/